module.exports = __webpack_public_path__ + "static/media/polygon-green.dad75e63.svg";